// src/store/modules/preferences.js
import api from "@/config/api";
import { handleApiError } from "@/utils/ErrorHandler";

export default {
  state: {
    preferredActivities: [],
    preferredWorkgroups: [],
    saveActivitiesResponse: null,
    saveWorkgroupsResponse: null,
    loadingPreferences: false,
  },

  mutations: {
    setPreferredActivities(state, activities) {
      state.preferredActivities = activities;
    },
    setPreferredWorkgroups(state, workgroups) {
      state.preferredWorkgroups = workgroups;
    },
    setSaveActivitiesResponse(state, response) {
      state.saveActivitiesResponse = response;
    },
    setSaveWorkgroupsResponse(state, response) {
      state.saveWorkgroupsResponse = response;
    },
    setLoadingPreferences(state, payload) {
      state.loadingPreferences = payload;
    },
  },

  actions: {
    // 1. Get preferred activities
    async fetchPreferredActivities({ commit }, { personId, locationId, peopleGroupId }) {
      commit("setLoadingPreferences", true);
      try {
        const response = await api.post("/managelocationajax", {
          cmd: "getpreferredactivities",
          locationid: locationId,
          personid: personId,
          people_group_id: peopleGroupId,
        });
        const data = response.data;
        commit("setPreferredActivities", data);
        return data;
      } catch (error) {
        handleApiError(error, "Failed to fetch preferred activities");
        throw error;
      } finally {
        commit("setLoadingPreferences", false);
      }
    },

    // 2. Get preferred workgroups
    async fetchPreferredWorkgroups({ commit }, { personId, locationId, peopleGroupId }) {
      commit("setLoadingPreferences", true);
      try {
        const response = await api.get(
          `/activities/location/${locationId}/preferred-workgroups`,
          { params: { person_id: personId, people_group_id: peopleGroupId } }
        );
        const data = response.data;
        commit("setPreferredWorkgroups", data);
        return data;
      } catch (error) {
        handleApiError(error, "Failed to fetch preferred workgroups");
        throw error;
      } finally {
        commit("setLoadingPreferences", false);
      }
    },

    // 3. Save preferred activities
    async savePreferredActivities({ commit }, { personId, locationId, peopleGroupId, activitiesArray }) {
      try {
        console.log("activitiesArray", activitiesArray);
        
        const response = await api.post("/manageuserajax", {
          cmd: "savepreferredactivities",
          personid: personId,
          locationid: locationId,
          people_group_id: peopleGroupId,
          activitiesarray: activitiesArray,
        });
        commit("setSaveActivitiesResponse", response.data);
        return response.data;
      } catch (error) {
        handleApiError(error, "Failed to save preferred activities");
        throw error;
      }
    },

    // 4. Save preferred workgroups
    async savePreferredWorkgroups({ commit }, { personId, locationId, peopleGroupId, workgroupsArray }) {
      try {
        const response = await api.post("/manageuserajax", {
          cmd: "savepreferredworkgroups",
          personid: personId,
          locationid: locationId,
          people_group_id: peopleGroupId,
          workgroupsarray: workgroupsArray,
        });
        commit("setSaveWorkgroupsResponse", response.data);
        return response.data;
      } catch (error) {
        handleApiError(error, "Failed to save preferred workgroups");
        throw error;
      }
    },
  },

  getters: {
    stPreferredActivities: (state) => state.preferredActivities,
    stPreferredWorkgroups: (state) => state.preferredWorkgroups,
    stSaveActivitiesResponse: (state) => state.saveActivitiesResponse,
    stSaveWorkgroupsResponse: (state) => state.saveWorkgroupsResponse,
    isPreferencesLoading: (state) => state.loadingPreferences,
  },
};